<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
import { useI18n } from 'vue-i18n';

defineProps({
    open: {
        type: Boolean,
        required: true,
    },
    variant: {
        type: String,
        required: true,
        validator: (value) => ['mobile', 'desktop'].includes(value),
    },
});

defineEmits(['toggle']);

const { t } = useI18n();
</script>

<template>
    <button
        type="button"
        data-testid="sidebar-collapse-button"
        class="button-collapse"
        :class="[
            open ? 'opened' : 'closed',
            variant === 'mobile' ? 'button-collapse-mobile' : 'button-collapse-desktop',
        ]"
        @click="$emit('toggle')"
    >
        <span
            v-if="variant === 'desktop'"
            class="label"
        >
            <span v-if="open">{{ t('general.collapse_menu') }}</span>
            <span v-else>{{ t('general.expand_menu') }}</span>
        </span>
        <span class="icon">
            <CFIcon
                name="collapse-menu"
                :class="{
                    'rotate-180': !open,
                }"
                class="h-4 text-white"
            />
        </span>
    </button>
</template>
